<!--
* @description  参数1
* @fileName  index
* @author userName
* @date 2024-01-15 11:59:53
!-->
<template>
  <div id="index" class="index">

    <div class="booking-before-dialog">
      <div class="booking-before">
        <div class="booking-before-top flex flex-column-center flex-row-between margin-top_32">
          <div>
            <div class="booking-before-top-title">预订</div>
            <div class="booking-before-top-text">
              填写下面所需的信息，以便我们的提供商可以处理您的货件。
            </div>
          </div>
          <button type="button" class="close-btn" @click="close">
            <span>关闭</span><i class="margin-left_8 el-icon-close" />
          </button>
        </div>
        <div class="booking-before-main ">
          <div class="booking-before-header">
            <div class="flex flex-column-center margin-top_16">
              <img src="../../../assets/img/client/booking/dian-icon.png" width="16px" height="16px">
              <div class="booking-before-header__line" />
              <img src="../../../assets/img/client/booking/dian-icon.png" width="16px" height="16px">
            </div>
            <div class="flex flex-column-center margin-top_16">
              <div class="flex-1 booking-before-header__text text-align-left">
                {{ data.startCityName }}｜{{ data.startCityZipcode }}
              </div>
              <img
                class="margin-left_24 margin-right_24"
                src="../../../assets/img/client/booking/icon／价格表／飞机.png"
                width="24px"
                height="24px"
              >
              <div class="flex-1 booking-before-header__text text-align-right">
                {{ businessType==3?'#'+data.storeCode+'|':'' }}{{ data.destCountryName }}｜{{ data.destCityNameEn }}
              </div>
            </div>
          </div>
          <div class="booking-before-content flex flex-column-center">
            <div class="flex-1">
              <div class="text1">业务类型</div>
              <div class="text2 margin-top_4">{{ GetBussinessType() }}</div>
            </div>
            <div class="flex-1">
              <div class="text1">时效</div>
              <div class="text2 margin-top_4">{{ data.workDays }} 天</div>
            </div>
            <div class="flex-1">
              <div class="text1">货好时间</div>
              <div v-if="data.goodsReadyType==1" class="text2 margin-top_4">已货好</div>
              <div v-if="data.goodsReadyType==2" class="text2 margin-top_4">两周内</div>
              <div v-if="data.goodsReadyType==3" class="text2 margin-top_4">两周以上</div>
            </div>
          </div>
          <div class="booking-before-info flex flex-column-center">
            <div class="flex-1">
              <div class="text1">材积信息</div>
              <div class="margin-top_4 flex flex-column-center">
                <div class="number flex flex-column-center flex-row-center">
                  <span>{{ data.quantity }}</span>
                </div>
                <div class="number-text flex flex-column-center flex-row-center">
                  X
                </div>
                <div class="flex-1 number-box flex flex-column-center padding-left_16">
                  <div>
                    <div class="flex flex-column-center">
                      <img
                        src="../../../assets/img/client/booking/box@2x.png"
                        width="16px"
                        height="16px"
                      >
                      <div class="text1">纸箱</div>
                    </div>
                    <!-- <div class="text2">52 × 50 × 45 cm</div> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-1 margin-left_24">
              <div class="text1">总重量/体积</div>
              <div class="margin-top_4 weight-box flex flex-column flex-column-center flex-row-center">
                <div class="text1">{{ data.weight }} KG</div>
                <div class="text2">{{ data.volume }} CBM</div>
              </div>
            </div>
            <div class="flex-1 margin-left_24">
              <div class="text1">保险公司</div>
              <div class="margin-top_4 company-box flex flex-row-start">
                <img
                  v-if="data.insuranceInfo.insuranceLogo"
                  :src="data.insuranceInfo.insuranceLogo"
                  width="159px"
                  height="56px"
                >
              </div>
            </div>
          </div>
          <div class="booking-before-tip flex flex-column-center">
            <i class="tip-icon el-icon-warning" />
            <div class="margin-left_4 tip-text">
              此费率有效期至 2023 年 11 月 14
              日。如果您的货物在此日期之后出发，或者实际装运负载与报价不同，则费率可能会根据市场费率进行调整。
            </div>
          </div>
          <div class="booking-before-bottom flex flex-row-end flex-column-center">
            <div class="total">总计：</div>
            <div v-if="data.totalAmount>0" class="price">CNY {{ data.totalAmount }}</div>
            <div v-else class="price">单询</div>
            <div class="detail margin-left_8">明细</div>
            <button type="button" class="confirm-btn margin-left_24" @click="toOrderDetail">
              <span>确认 & 预定发货</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <ExpOrder v-if="isExpOrder" ref="ExpOrder" @close="() => { isExpOrder = false }" />
    <AirOrder v-if="isAirOrder" ref="AirOrder" @close="() => { isAirOrder = false }" />
    <FbaOrder v-if="isFbaOrder" ref="FbaOrder" @close="() => { isFbaOrder = false }" />
    <SeaOrder v-if="isSeaOrder" ref="SeaOrder" @close="() => { isSeaOrder = false }" />
  </div>

</template>

<script>
import {
  GetFbaOrderDetail,
  GetAirOrderDetail,
  GetExpOrderDetail,
  GetSeaOrderDetail
} from '@/api/order.js'
import ExpOrder from '@/client/home/placeAnOrder/exp/confirmOrder.vue'
import AirOrder from '@/client/home/placeAnOrder/air/confirmOrder.vue'
import FbaOrder from '@/client/home/placeAnOrder/fba/confirmOrder.vue'
import SeaOrder from '@/client/home/placeAnOrder/sea/confirmOrder.vue'
import define from '@/utils/define.js'
export default {
  name: 'Index',
  components: {
    ExpOrder,
    AirOrder,
    FbaOrder,
    SeaOrder
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      active: 3,
      isConfirmOrder: false,
      orderNo: '',
      businessType: undefined,
      isExpOrder: false,
      isAirOrder: false,
      isFbaOrder: false,
      isSeaOrder: false,
      data: {
        insuranceInfo: {}
      }
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {},
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    init(orderNo, businessType) {
      this.orderNo = orderNo
      this.businessType = businessType
      switch (businessType) {
        case 1:
          this.getExpOrder()
          break
        case 2:
          this.getAirOrder()
          break
        case 3:
          this.getFbaOrder()
          break
        case 4:
          this.getSeaOrder()
          break
      }
    },
    getFbaOrder() {
      GetFbaOrderDetail(this.orderNo).then(res => {
        if (res.code === 200) {
          this.data = res.data
          if (this.data.customsSupplierLogo) {
            var logoJson = JSON.parse(this.data.customsSupplierLogo)
            if (logoJson.length > 0) {
              this.data.customsSupplierLogo = define.comUrl + logoJson[0].url
            } else {
              this.data.customsSupplierLogo = undefined
            }
          }
          if (this.data.insuranceInfo.insuranceLogo) {
            this.data.insuranceInfo.insuranceLogo = define.comUrl + this.data.insuranceInfo
              .insuranceLogo
          } else {
            this.data.insuranceInfo.insuranceLogo = undefined
          }
		  if (this.data.traffic == 0) {
			  this.data.totalAmount = 0
		  } else {
			  this.data.subTotal1 = this.data.traffic
			  this.data.feeList.forEach(item => {
			    this.data.subTotal1 += item.totalAmount
			  })
			  this.data.subTotal1 += this.data.startLiftgateAmount
			  this.data.subTotal2 = this.data.bondAmount + this.data.ISFBondAmount
			  this.data.customsFeeList.forEach(item => {
			    this.data.subTotal2 += item.totalAmount
			  })
			  if (this.data.insuranceInfo.buyAmount) {
			    this.totalAmount += this.data.insuranceInfo.insuranceRate
			  }
		  }
        }
      })
    },
    getExpOrder() {
      GetExpOrderDetail(this.orderNo).then(res => {
        if (res.code === 200) {
          this.data = res.data
          this.expCompanyLogo = this.filterData(this.data.modeCodePage)
          if (this.data.insuranceInfo.insuranceLogo) {
            this.data.insuranceInfo.insuranceLogo = define.comUrl + this.data
              .insuranceInfo.insuranceLogo
          } else {
            this.data.insuranceInfo.insuranceLogo = undefined
          }
          this.data.subTotal1 = this.data.orderTransferFee
          this.data.feeList.forEach(item => {
            this.data.subTotal1 += item.totalAmount
          })
          this.data.subTotal1 += this.data.startLiftgateAmount
        }
      })
    },
    getAirOrder() {
      GetAirOrderDetail(this.orderNo).then(res => {
        if (res.code === 200) {
          this.data = res.data
          if (this.data.airSupplierLogo != null) {
            this.data.airSupplierLogo = define.comUrl + this.data.airSupplierLogo
          }
          if (this.data.insuranceLogo) {
            this.data.insuranceLogo = define.comUrl + this.data.insuranceLogo
          } else {
            this.data.insuranceLogo = undefined
          }
          this.data.insuranceInfo = {}
          this.data.insuranceInfo.insuranceLogo = this.data.insuranceLogo
          this.data.feeList.forEach(item => {
            this.otherAmount += item.Amount
          })
          if (this.data.bondAmount) {
            this.otherAmount += this.data.bondAmount
          }
          if (this.data.startLiftgateAmount) {
            this.otherAmount += this.data.startLiftgateAmount
          }
          if (this.data.destLiftgateAmount) {
            this.otherAmount += this.data.destLiftgateAmount
          }
          if (this.data.deliveryAmount) {
            this.otherAmount += this.data.deliveryAmount
          }
          if (this.data.pickupAmount) {
            this.otherAmount += this.data.pickupAmount
          }
          this.data.startCityZipcode = this.data.startCityZipCode
          this.data.workDays = this.data.validTerm
        }
      })
    },
    getSeaOrder() {
      GetSeaOrderDetail(this.orderNo).then(res => {
        if (res.code === 200) {
          this.data = res.data
          if (this.data.seaSupplierLogo) {
            this.data.seaSupplierLogo = define.comUrl + this.data.seaSupplierLogo
          } else {
            this.data.seaSupplierLogo = undefined
          }
          if (this.data.insuranceLogo) {
            this.data.insuranceLogo = define.comUrl + this.data.insuranceLogo
          } else {
            this.data.insuranceLogo = undefined
          }
          this.data.insuranceInfo = {}
          this.data.insuranceInfo.insuranceLogo = this.data.insuranceLogo
          this.data.feeList.forEach(item => {
            this.otherAmount += item.Amount
          })
          if (this.data.bondAmount) {
            this.otherAmount += this.data.bondAmount
          }
          if (this.data.startLiftgateAmount) {
            this.otherAmount += this.data.startLiftgateAmount
          }
          if (this.data.destLiftgateAmount) {
            this.otherAmount += this.data.destLiftgateAmount
          }
          if (this.data.deliveryAmount) {
            this.otherAmount += this.data.deliveryAmount
          }
          if (this.data.pickupAmount) {
            this.otherAmount += this.data.pickupAmount
          }
          this.data.startCityZipcode = this.data.startCityZipCode
          this.data.workDays = this.data.DepartureDay
        }
      })
    },
    filterData(data) {
      switch (data) {
        case 'DHL':
          return define.comUrl + 'DHL.png'
        case 'DPD':
          return define.comUrl + 'DPD.png'
        case 'FEDEX':
          return define.comUrl + 'FEDEX.png'
        case 'UPS':
          return define.comUrl + 'UPS.png'
        case 'E-LINE':
          return define.comUrl + 'E-LINE.png'
        case 'LINE':
          return define.comUrl + 'LINE.png'
        default:
          return undefined
      }
    },
    toOrderDetail() {
      switch (this.businessType) {
        case 1:
          this.isExpOrder = true
          this.$nextTick(() => {
            this.$refs.ExpOrder.init(this.data)
          })

          break
        case 2:
          this.isAirOrder = true
          this.$nextTick(() => {
            this.$refs.AirOrder.init(this.data)
          })

          break
        case 3:
          this.isFbaOrder = true
          this.$nextTick(() => {
            this.$refs.FbaOrder.init(this.data)
          })

          break
        case 4:
          this.isSeaOrder = true
          this.$nextTick(() => {
            this.$refs.SeaOrder.init(this.data)
          })
          break
      }
      // this.close()
    },
    close() {
      this.$emit('close')
    },
    GetOriginAddress() {
      switch (this.queryData.businessType) {
        case 1:
          return `${this.queryData.originName}`
        case 2:
          return `${this.queryData.startPortCode}`
        case 3:
          return `${this.originName}`
        case 4:
          return `${this.originName}`
      }
    },
    GetDestAddress() {
      switch (this.queryData.businessType) {
        case 1:
          return `${this.queryData.destinationName}`
        case 2:
          return `${this.queryData.destPortCode}`
        case 3:
          return `${this.originName}`
        case 4:
          return `${this.originName}`
      }
    },
    GetBussinessType() {
      switch (this.businessType) {
        case 1:
          return '快递'
        case 2:
          return '空运'
        case 3:
          return 'FBA'
        case 4:
          return '海运'
      }
    }
  }
}
</script>
<style scoped lang='scss'>
	.booking-before-dialog {
		position: fixed;
		z-index: 100;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		overflow: auto;
		margin: 0;
		background: rgba(0, 0, 0, 0.04);
		backdrop-filter: blur(8px);

		.booking-before {
			margin: 0 auto;
			width: 1200px;
			box-sizing: border-box;

			.booking-before-top {
				padding-bottom: 16px;

				.booking-before-top-title {
					font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
					font-weight: bold;
					font-size: 20px;
					color: #333333;
					line-height: 27px;
					text-align: left;
					font-style: normal;
				}

				.booking-before-top-text {
					margin-top: 8px;
					font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
					font-weight: 400;
					font-size: 12px;
					color: #777777;
					line-height: 17px;
					text-align: left;
					font-style: normal;
				}

				.close-btn {
					outline: none;
					border: none;
					width: 78px;
					height: 32px;
					background: rgba(0, 0, 0, 0.08);
					border-radius: 8px;

					span {
						display: inline-block;
						font-family: PingFangSC, PingFang SC;
						font-weight: 600;
						font-size: 14px;
						color: #333333;
						line-height: 20px;
						text-align: right;
						font-style: normal;
					}

					i {
						font-size: 14px;
						font-weight: bold;
						color: #333;
					}

					&:hover {
						cursor: pointer;
					}
				}
			}

			.booking-before-main {
				padding: 8px;
				background: #ffffff;
				border-radius: 16px;

				.booking-before-header {
					padding: 16px 24px;
					height: 112px;
					background: #f5f7fa;
					border-radius: 10px;
					box-sizing: border-box;

					.booking-before-header__line {
						flex: 1;
						height: 1px;
						border-top: 2px dashed rgba(51, 112, 255, 0.8);
					}

					.booking-before-header__text {
						font-family: PingFangSC, PingFang SC;
						font-weight: 600;
						font-size: 16px;
						color: #333333;
						line-height: 22px;
						font-style: normal;
					}
				}

				.booking-before-content {
					margin: 0 24px;
					min-height: 88px;
					background: rgba(255, 255, 255, 0);
					border-bottom: 1px solid #ddd;
					box-sizing: border-box;

					.text1 {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 12px;
						color: #777777;
						line-height: 20px;
						text-align: left;
						font-style: normal;
					}

					.text2 {
						font-family: PingFangSC, PingFang SC;
						font-weight: 600;
						font-size: 14px;
						color: #333333;
						line-height: 24px;
						text-align: left;
						font-style: normal;
					}
				}

				.booking-before-info {
					margin: 0 24px;
					height: 118px;
					background: rgba(255, 255, 255, 0);
					border-bottom: 1px solid #ddd;
					box-sizing: border-box;

					.text1 {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 12px;
						color: #777777;
						line-height: 20px;
						text-align: left;
						font-style: normal;
					}

					.number {
						width: 38px;
						height: 56px;
						background: rgba(51, 112, 255, 0.04);
						border-radius: 8px;
						box-sizing: border-box;

						span {
							display: inline-block;
							font-family: PingFangSC, PingFang SC;
							font-weight: 600;
							font-size: 16px;
							color: #333333;
							line-height: 22px;
							text-align: center;
							font-style: normal;
						}
					}

					.number-text {
						width: 38px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 600;
						font-size: 14px;
						color: #333333;
						line-height: 20px;
						text-align: center;
						font-style: normal;
					}

					.number-box {
						height: 56px;
						background: rgba(51, 112, 255, 0.04);
						border-radius: 8px;

						.text1 {
							font-family: PingFangSC, PingFang SC;
							font-weight: 600;
							font-size: 13px;
							color: #333333;
							line-height: 18px;
							text-align: left;
							font-style: normal;
						}

						.text2 {
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							font-size: 13px;
							color: #333333;
							line-height: 18px;
							text-align: left;
							font-style: normal;
						}
					}

					.weight-box {
						height: 56px;
						background: rgba(51, 112, 255, 0.04);
						border-radius: 8px;
						box-sizing: border-box;

						.text1 {
							font-family: PingFangSC, PingFang SC;
							font-weight: 600;
							font-size: 13px;
							color: #333333;
							line-height: 18px;
							text-align: center;
							font-style: normal;
						}

						.text2 {
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							font-size: 13px;
							color: #333333;
							line-height: 18px;
							text-align: center;
							font-style: normal;
						}
					}

					.company-box {
						height: 56px;
						background: rgba(51, 112, 255, 0);
						border-radius: 8px;
						box-sizing: border-box;
					}
				}

				.booking-before-tip {
					margin: 24px 24px;
					padding: 0 8px;
					min-height: 40px;
					background: rgba(2, 127, 252, 0.04);
					border-radius: 4px;
					box-sizing: border-box;

					.tip-icon {
						font-size: 16px;
						color: #3370ff;
					}

					.tip-text {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 13px;
						color: #3370ff;
						line-height: 20px;
						text-align: left;
						font-style: normal;
					}
				}

				.booking-before-bottom {
					padding: 0 24px 24px 24px;

					.total {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 13px;
						color: #777777;
						line-height: 18px;
						text-align: right;
						font-style: normal;
					}

					.price-unit {}

					.price {
						font-family: D-DINExp, D-DINExp;
						font-weight: bold;
						font-size: 24px;
						color: #ef0a0a;
						line-height: 26px;
						text-align: right;
						font-style: normal;
					}

					.detail {
						cursor: pointer;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 13px;
						color: #3370ff;
						line-height: 18px;
						text-align: right;
						font-style: normal;
					}

					.confirm-btn {
						outline: none;
						border: none;
						width: 200px;
						height: 40px;
						background: rgb(51, 112, 255);
						border-radius: 8px;
						transition: all 0.3s;
						box-sizing: border-box;

						span {
							display: inline-block;
							font-family: PingFangSC, PingFang SC;
							font-weight: 600;
							font-size: 16px;
							color: #ffffff;
							line-height: 22px;
							text-align: center;
							font-style: normal;
						}

						&:hover {
							cursor: pointer;
							background: rgba(51, 112, 255, 0.8);
						}
					}
				}
			}
		}
	}
</style>
